export default __webpack_public_path__ + "static/assets/cloudinaryError.c83bdf4a.svg";